import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ExpandIndicatorComponent } from '../../../../../common/components/expand.indicator/expand.indicator.component';
import { MatMenu } from '@angular/material/menu';
import { SharedModule } from '../../../../shared/shared.module';
import { FormsModule } from '@angular/forms';

import { MatTabsModule } from '@angular/material/tabs';
import { NgIf } from '@angular/common';
import { TabImageLinkFileSelectorComponent } from '../../../../../common/components/tab.image.link.file.selector/tab.image.link.file.selector.component';

@Component({
  selector: 'ig-itinerary-image-uploader',
  standalone: true,
  imports: [
    ExpandIndicatorComponent,
    MatMenu,
    SharedModule,
    MatTabsModule,
    NgIf,
    FormsModule,
    TabImageLinkFileSelectorComponent,
  ],
  templateUrl: './itinerary.image.uploader.component.html',
  styleUrl: './itinerary.image.uploader.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ItineraryImageUploaderComponent {
  @Input() initialImg = '';
  @Input() triggerText = '';
  @Output() onImageUploaded = new EventEmitter<any>();
}
